<template>
  <!-- 添加搜索输入框 -->
  <div style="margin-bottom: 10px;display: flex;">
    <el-input v-if="false" placeholder="请输入搜索关键词" v-model.trim="searchKeyword" clearable
      @keyup.enter="handleSearch"></el-input>
    <el-button v-if="false" type="primary" @click="handleSearch" style="margin-left: 15px;">搜索</el-button>
    <div style="width: 20%;">
      <el-date-picker v-model="date" type="daterange" unlink-panels range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期" value-format="YYYY-MM-DD" @change="onDateChange" trigger="click" />
    </div>

  </div>
  <div v-if="tableData.length > 0">
    <el-table :data="tableData" style="width: 100%" height="350" :header-cell-style="{
      background: '#222222',
      color: '#fff',
      borderBottom: '1px solid #444'
    }" :cell-style="{
      background: '#28292d',
      color: '#e4e6ea'
    }" :row-style="{ background: '#28292d' }" :row-class-name="tableRowClassName" stripe highlight-current-row>
      <el-table-column type="index" label="序号" width="80" />
      <!-- <el-table-column prop="id" label="ID" width="180" /> -->
      <!-- <el-table-column prop="benefitId" label="权益id" width="180" /> -->
      <!-- <el-table-column prop="benefitCode" label="权益代码" /> -->
      <el-table-column prop="benefitName" label="标题" />
      <!-- <el-table-column prop="benefitType" label="权益类型" /> -->
      <!-- <el-table-column prop="unit" label="计价单位" /> -->
      <!-- <el-table-column prop="price" label="单价（积分）" /> -->
      <!-- <el-table-column prop="timeCycle" label="时间周期" /> -->
      <el-table-column prop="changeType" label="变动类型" />
      <el-table-column prop="point" label="积分变动" />
      <!-- <el-table-column prop="createId" label="创建人ID" /> -->
      <el-table-column prop="createTime" label="时间" />
    </el-table>

    <el-pagination style="justify-content: flex-end;
    margin-top: 10px;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total" :disabled="tableData.length === 0" />
  </div>
  <div v-else>
    <p>暂无数据</p>
  </div>
</template>

<script setup>

import { ref, onMounted, watch, defineProps, computed, reactive } from 'vue';
import { useMainStore } from '@/pinia';
import { getAppPointHistoryPage } from '@/request/index.ts'
const store = useMainStore();
let teamInfo = ref(store.teamInfo)
let userInfo = ref(store.userInfo)

// 假设这是您的数据源
let tableData = ref([
  // 这里应该通过API获取真实数据并填充
])

let searchKeyword = ref('');
let date = ref('');

const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(0);
const startDate = ref('');
const endDate = ref('');

// 处理搜索操作的方法
const handleSearch = () => {
  fetchData(1, pageSize.value,); // 重置到第一页并进行搜索
};

// 查看时间
let onDateChange = () => {
  if (date.value) {
    startDate.value = date.value[0]
    endDate.value = date.value[1]
  } else {
    startDate.value = ''
    endDate.value = ''
  }

  fetchData(1, pageSize.value);
}


// 获取数据并处理分页
const fetchData = async (pageIndex = 1, size = pageSize.value,) => {
  try {
    const response = await getAppPointHistoryPage({
      keyword: '',
      // userId: userInfo.value.userId,
      // teamId: teamInfo.value.id,
      pageIndex, // 调整为0-based索引
      pageSize: size,
      startDate: startDate.value,
      endDate: endDate.value,
    });

    tableData.value = response.data.data.list;
    total.value = response.data.data.total; // 设置总条数
    currentPage.value = pageIndex; // 确保currentPage与请求的页码同步
    pageSize.value = size; // 同步每页大小
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

// 初始化加载数据
onMounted(() => {
  fetchData();
});

// 分页处理函数
const handleSizeChange = (val) => {
  pageSize.value = val;
  fetchData(currentPage.value, val); // 重新获取数据
};

const handleCurrentChange = (val) => {
  console.log('valval', val);
  currentPage.value = val;
  fetchData(val); // 重新获取数据
};

// 添加斑马纹样式
const tableRowClassName = ({ rowIndex }) => {
  return rowIndex % 2 === 0 ? '' : 'stripe-row';
}

</script>

<style lang="scss" scoped>
.el-table {
  // 表格边框和圆角
  border: 1px solid #444;
  border-radius: 8px;

  // hover 效果
  .el-table__row:hover>td {
    background-color: #222222 !important;
  }

  // 斑马纹样式
  .stripe-row {
    background-color: #1a1a1a !important;
  }

  // 选中行样式
  .current-row>td {
    background: linear-gradient(90deg, #5654f9 0%, #7f54f9 100%) !important;
    color: #fff !important;
  }

  // 表格内边框
  td {
    border-bottom: 1px solid #444;
  }
}
</style>
